import { isAction } from "@reduxjs/toolkit";
import { CustomMetaAction } from "../../models/middlewereAction";
import { ErrorDataResponse, errorResponseSchema } from "../../models/errors/errorResponse";

export const isCustomMetaAction = (action: unknown): action is CustomMetaAction => {
  if (typeof action !== "object" || action === null) {
    return false;
  }

  const maybeCustomAction = action as Partial<CustomMetaAction>;

  if (!("meta" in maybeCustomAction)) {
    return false;
  }

  const meta = maybeCustomAction.meta;

  if (typeof meta !== "object" || meta === null) {
    return false;
  }

  return (
    "baseQueryMeta" in meta &&
    "arg" in meta &&
    typeof meta.arg === "object" &&
    meta.arg !== null &&
    "endpointName" in meta.arg &&
    typeof meta.arg.endpointName === "string"
  );
};

export const isValidErrorPayload = (payload: unknown): payload is ErrorDataResponse => {
  return errorResponseSchema.safeParse(payload).success;
};

export const isFulfilledCustomMetaAction = (action: unknown): action is CustomMetaAction => {
  return isAction(action) && isCustomMetaAction(action);
};
